import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Observable, ReplaySubject, map } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';
import { HighlightPipe } from 'ish-core/pipes/highlight.pipe';
import { ProductImageComponent } from 'ish-shared/components/product/product-image/product-image.component';

@Component({
  selector: 'ish-suggest-products-tile',
  imports: [CommonModule, HighlightPipe, RouterModule, ProductImageComponent],
  templateUrl: './suggest-products-tile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestProductsTileComponent implements OnInit {
  private context = inject(ProductContextFacade);

  readonly inputTerms$ = input(new ReplaySubject<string>(1));
  readonly deviceType = input<DeviceType>(undefined);
  readonly routeChange = output<void>();

  productURL$: Observable<string>;
  productName$: Observable<string>;

  ngOnInit() {
    this.productURL$ = this.context.select('productURL');
    this.productName$ = this.context
      .select('product', 'name')
      // truncate product name on desktop only
      .pipe(map(name => (this.deviceType() === 'desktop' ? this.truncate(name, 38) : name)));
  }

  private truncate(text: string, limit: number): string {
    return text.length > limit + 3 ? `${text.substring(0, limit)}...` : text;
  }

  handleInputFocus(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.routeChange.emit();
  }
}
